import { render, staticRenderFns } from "./addInkhubMonthly.vue?vue&type=template&id=0b9af456&scoped=true"
import script from "./addInkhubMonthly.vue?vue&type=script&lang=js"
export * from "./addInkhubMonthly.vue?vue&type=script&lang=js"
import style0 from "./addInkhubMonthly.vue?vue&type=style&index=0&id=0b9af456&lang=scss&scoped=true"
import style1 from "./addInkhubMonthly.vue?vue&type=style&index=1&id=0b9af456&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9af456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9af456')) {
      api.createRecord('0b9af456', component.options)
    } else {
      api.reload('0b9af456', component.options)
    }
    module.hot.accept("./addInkhubMonthly.vue?vue&type=template&id=0b9af456&scoped=true", function () {
      api.rerender('0b9af456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/addInkhubMonthly.vue"
export default component.exports